import { useParams } from 'react-router';

import { Asset } from '../app/entities/asset';

export const useCurrentAsset = () => {
  const { assetId } = useParams() as { assetId: string };

  return Asset.getOne(assetId);
};
